import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
var MiniPlayer = function () {
    function MiniPlayer(player) {
        _classCallCheck(this, MiniPlayer);
        this.player = player;
        this.show();
    }
    return _createClass(MiniPlayer, [
        {
            key: 'show',
            value: function show() {
                this.player.template.container.classList.add('mini-player');
            }
        },
        {
            key: 'hide',
            value: function hide() {
                this.player.template.container.classList.remove('mini-player');
            }
        },
        {
            key: 'toggle',
            value: function toggle() {
            }
        }
    ]);
}();
export default MiniPlayer;